// extracted by mini-css-extract-plugin
export default {"container":"mk-z","bubbleNav":"nk-z","graphic":"ok-z","contact":"pk-z"};